var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"icon":"el-icon-d-arrow-right"},on:{"click":_vm.handleClick}},[_vm._v(" 转至"+_vm._s(_vm.aim)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }